import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

/**
 * Design 2.0 inline warning strip — yellow surface + info icon + message.
 * Used inside cards to convey "nothing here yet" / "missing data" states.
 */
@Component({
  selector: 'app-v2-warn-strip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './v2-warn-strip.component.html',
  styleUrls: ['./v2-warn-strip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class V2WarnStripComponent {
  @Input() icon: string = 'fas fa-info-circle';
}
